
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import domtoimage from "dom-to-image";
import { Loading } from "element-ui";
import { formatUpyunUrl } from "@/utils";
import { dateToStr, numToStrM } from "@/utils/index";
import Avatar from "@/components/Avatar.vue";
@Component({
  components: { Avatar },

  filters: {
    getStatus(type: any): string {
      let txt = "";
      if (type == 0) {
        txt = "学习中";
      } else if (type == 1) {
        txt = "已结业";
      } else if (type == 2) {
        txt = "7级";
      } else if (type == 3) {
        txt = "11级";
      } else if (type == 4) {
        txt = "大师级";
      }
      return txt;
    }
  }
})
export default class MBA extends Vue {
  dUser = require("@/assets/images/user.png");
  dUserRect = require("@/assets/images/user_rect.png");
  @Prop({ default: {} }) info!: any;
  isDown = false;
  formatUpyunUrl = formatUpyunUrl;
  dateToStr = dateToStr;
  numToStrM = numToStrM;

  options = [] as any;

  @Watch("info")
  infoChange() {
    this.options = [];

    if (this.info.cert_list) {
      if (this.info.cert_list.indexOf(3) != -1) {
        if (window.$getCookie("zh_choose") == "t") {
          this.options.push({
            value: 1,
            label: "BLM管理大師證書(大师級)"
          });
        } else {
          this.options.push({
            value: 1,
            label: "BLM管理大师证书(大师级)"
          });
        }
      }
      if (this.info.cert_list.indexOf(2) != -1) {
        if (window.$getCookie("zh_choose") == "t") {
          this.options.push({
            value: 3,
            label: "BLM管理大師證書(11級)"
          });
        } else {
          this.options.push({
            value: 3,
            label: "BLM管理大师证书(11级)"
          });
        }
      }
      if (this.info.cert_list.indexOf(1) != -1) {
        if (window.$getCookie("zh_choose") == "t") {
          this.options.push({
            value: 2,
            label: "BLM管理大師證書(7級)"
          });
        } else {
          this.options.push({
            value: 2,
            label: "BLM管理大师证书(7级)"
          });
        }
      }

      if (this.info.cert_list.indexOf(3) != -1) {
        this.value = 1;
      } else if (this.info.cert_list.indexOf(2) != -1) {
        this.value = 3;
      } else if (this.info.cert_list.indexOf(1) != -1) {
        this.value = 2;
      }
    }
  }

  mounted() {
    if (this.info.cert_list) {
      if (this.info.cert_list.indexOf(3) != -1) {
        if (window.$getCookie("zh_choose") == "t") {
          this.options.push({
            value: 1,
            label: "BLM管理大師證書(大师級)"
          });
        } else {
          this.options.push({
            value: 1,
            label: "BLM管理大师证书(大师级)"
          });
        }
      }
      if (this.info.cert_list.indexOf(2) != -1) {
        if (window.$getCookie("zh_choose") == "t") {
          this.options.push({
            value: 3,
            label: "BLM管理大師證書(11級)"
          });
        } else {
          this.options.push({
            value: 3,
            label: "BLM管理大师证书(11级)"
          });
        }
      }
      if (this.info.cert_list.indexOf(1) != -1) {
        if (window.$getCookie("zh_choose") == "t") {
          this.options.push({
            value: 2,
            label: "BLM管理大師證書(7級)"
          });
        } else {
          this.options.push({
            value: 2,
            label: "BLM管理大师证书(7级)"
          });
        }
      }

      if (this.info.cert_list.indexOf(3) != -1) {
        this.value = 1;
      } else if (this.info.cert_list.indexOf(2) != -1) {
        this.value = 3;
      } else if (this.info.cert_list.indexOf(1) != -1) {
        this.value = 2;
      }
    }
  }

  value = 0 as any;
  index = 0 as any;

  pre() {
    if (this.value < this.options[this.index].value) {
      return false;
    }
    if (this.index > 0) {
      this.index--;
      this.value = this.options[this.index].value;
    }
  }

  next() {
    if (this.value > this.options[this.index].value) {
      return false;
    }
    if (this.index < this.options.length - 1) {
      this.index++;
      this.value = this.options[this.index].value;
    }
  }

  reduMonths(startMonth: any, endMonth: any) {
    let startY = startMonth.split("-")[0],
      startM = startMonth.split("-")[1],
      endY = endMonth.split("-")[0],
      endM = endMonth.split("-")[1];
    startMonth = startY + startM;
    endMonth = endY + endM;
    if (startMonth > endMonth) {
      let reduY = startY - endY,
        reduM = startM - endM;
      return reduY * 12 + reduM;
    } else if (startMonth < endMonth) {
      let reduY = endY - startY,
        reduM = endM - startM;

      return reduY * 12 + reduM;
    } else {
      return 0;
    }
  }

  save(index: number) {
    let load = Loading.service({
      lock: true,
      text: "生成图片中...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.9)"
    });
    let node: any = null;
    let txt = "";
    if (index === 1) {
      node = document.getElementById("certificate8");
      txt = "BLM学籍";
    } else {
      if (this.value == 1) {
        node = document.getElementById("certificate9");
        txt = "BLM科學經營™證書";
      } else if (this.value == 2) {
        node = document.getElementById("certificate10");
        txt = "BLM科學經營™證書";
      } else if (this.value == 3) {
        node = document.getElementById("certificate11");
        txt = "BLM科學經營™證書";
      }
    }
    const scale = 2;
    const options = {
      width: node.clientWidth * scale,
      height: node.clientHeight * scale,
      style: {
        transform: "scale(" + scale + ")",
        transformOrigin: "top left"
      }
    };
    const that = this;

    this.isDown = true;
    domtoimage.toPng(node, options).then(function(dataUrl: any) {
      let eleLink = document.createElement("a");
      eleLink.href = dataUrl; // 转换后的图片地址
      eleLink.download = txt;
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
      that.isDown = false;
      load.close();
    });
  }

  selectChange(val: any) {
    for (let index = 0; index < this.options.length; index++) {
      const element = this.options[index];
      if (element.value == val) {
        this.index = index;
        return false;
      }
    }
  }
}
